document.querySelectorAll('.mega-menu__link, .header__menu-item').forEach(link => {
  link.addEventListener('click', () => {
    const navHeader = link.closest('.mega-menu') 
      ? link.closest('.mega-menu').querySelector('summary span').textContent.trim()
      : 'Main Menu';
    
    const navSubheader = link.closest('.custom_main_linklist > li')
      ? link.closest('.custom_main_linklist > li').querySelector('a.mega-menu__link--level-2')?.textContent.trim() 
      : '';
    
    const navText = link.textContent.trim();


    console.log(navHeader,navSubheader, navText )
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'top_navigation',
      'nav_header': navHeader,
      'nav_subheader': navSubheader,
      'nav_text': navText,
    });
  });
});




function addToCartDataLayer() {
  const titleElement = document.querySelector('.product__title h1, .product__title h2');
  const productTitle = titleElement ? titleElement.innerText.trim() : '';
  const idElement = document.querySelector('.product_id');
  const productID = idElement ? idElement.innerText.trim() : '';
  const categoryElement = document.querySelector('.product_category .pd_text');
  const productcategory = categoryElement ? categoryElement.innerText.trim() : ''; 
  const priceElement = document.querySelector('.price-item--last');
  const productPrice = priceElement ? priceElement.innerText.replace(/[^\d.-]/g, '').trim() : '';
  console.log(productTitle, productPrice) 
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      
      items: [
        {
          item_name: productTitle,
          price: parseFloat(productPrice),
          quantity: 1,
          item_id: productID,
           item_category: productcategory,
           item_brand: "Celio"
        }
      ]
    }
  });
}


function addToWishlistDataLayer() {
  const titleElement = document.querySelector('.product__title h1, .product__title h2');
  const productTitle = titleElement ? titleElement.innerText.trim() : '';
  const idElement = document.querySelector('.product_id');
  const productID = idElement ? idElement.innerText.trim() : '';
  const categoryElement = document.querySelector('.product_category .pd_text');
  const productcategory = categoryElement ? categoryElement.innerText.trim() : ''; 
  const priceElement = document.querySelector('.price-item--last');
  const productPrice = priceElement ? priceElement.innerText.replace(/[^\d.-]/g, '').trim() : '';
  console.log(productTitle, productPrice) 
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "add_to_wishlist",
    ecommerce: {
      
      items: [
        {
          item_name: productTitle,
          price: parseFloat(productPrice),
          quantity: 1,
              item_id: productID,
           item_category: productcategory,
           item_brand: "Celio"
        }
      ]
    }
  });
}


document.querySelector('.cart__checkout-button').addEventListener('click', function() {
  const total = document.querySelector(".totals__total-value");
    const totalValue = parseFloat(total.textContent.replace(/[^0-9.]/g, ''));
  console.log(totalValue);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "begin_checkout", 
    ecommerce: {
     currency: "INR",
     value: totalValue,
    }
  });
});



document.querySelector('#cart-icon-bubble').addEventListener('click', function() {
  const total = document.querySelector(".totals__total-value");
  const totalValue = parseFloat(total.textContent.replace(/[^0-9.]/g, ''));
  const items = [];

  document.querySelectorAll(".cart-item").forEach((item) => {
    const name = item.querySelector(".cart-item__name").textContent.trim();
    const id = item.querySelector(".cart-item-id").textContent.trim();
    const category = item.querySelector(".cart-item-category").textContent.trim();
    const quantity = parseInt(item.querySelector(".quantity__input").value, 10);
    const priceText = item.querySelector(".cart-item__price-wrapper .price").textContent.trim();
    const price = parseFloat(priceText.replace(/[^0-9.]/g, ''));

    items.push({
      item_brand: "Celio",
      item_name: name,
      item_id: id,
      item_category: category,
      quantity: quantity,
      price: price,
    });
  });

  console.log(items); 

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "view_cart",
    ecommerce: {
      currency: "INR",
      value: totalValue,
      items: items
    }
  });
});





function trackViewItemEvent() {
  const titleElement = document.querySelector('.product__title h1, .product__title h2');
  const productTitle = titleElement ? titleElement.innerText.trim() : '';
    const idElement = document.querySelector('.product_id');
  const productID = idElement ? idElement.innerText.trim() : '';
  const categoryElement = document.querySelector('.product_category .pd_text');
  const productcategory = categoryElement ? categoryElement.innerText.trim() : ''; 
  const priceElement = document.querySelector('.price-item--last');
  const productPrice = priceElement ? priceElement.innerText.replace(/[^\d.-]/g, '').trim() : '';

console.log("this is product page.");
console.log(productTitle, productPrice) 
  
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "view_item",
    ecommerce: {   
      currency: "INR",
      value: parseFloat(productPrice),
      items: [
        {
          item_name: productTitle,
          price: parseFloat(productPrice),
          quantity: 1,
              item_id: productID,
           item_category: productcategory,
           item_brand: "Celio"
        }
      ]
    }
  });
}








